/* tslint:disable */

/**
 */
export class ShiftDestroyForm {
    from_date?: string;
    to_date?: string;
    accept?: number;
}
